import BaseApi from "./BaseApi";

export default class Events extends BaseApi {
    construct() { }


    static async create(params) {
        return await Events.getAxiosInstance().post(Events.getApiUrl(), params);
    }

    static async getByUser() {
        return await Events.getAxiosInstance().get(Events.getApiUrl() + 'list');
    }

    static async get(id) {
        return await Events.getAxiosInstance().get(Events.getApiUrl() + id);
    }

    static async update(id, params) {
        return Events.getAxiosInstance().put(Events.getApiUrl() + id, params);
    }

    static async delete(id) {
        return await this.getAxiosInstance().delete(Events.getApiUrl() + id);
    }

    static async reopen(id) {
        return Events.getAxiosInstance().post(Events.getApiUrl() + 'reopen', { event_id: id });
    }

    static async insertTime(params) {
        return Events.getAxiosInstance().post(BaseApi.getApiUrl() + "api/matchcalendar/user-votes", params);
    }

    static async insertTimeFullDay(params) {
        return Events.getAxiosInstance().post(Events.getApiUrl() + 'insert-time-full-day', params);
    }

    static async getTimes(id, date) {
        return await Events.getAxiosInstance().get(Events.getApiUrl() + 'get-times/' + id + '/' + date);
    }

    static async getResults(id) {
        return await Events.getAxiosInstance().get(Events.getApiUrl() + 'event-results/' + id);
    }

    static async invite(params) {
        return Events.getAxiosInstance().post(Events.getApiUrl() + 'invite', params);
    }

    static getApiUrl() {
        return BaseApi.getApiUrl() + "api/matchcalendar/event/";
    }

    static async getByHash(hash) {
        return await Events.getAxiosInstance().get(Events.getApiUrl() + 'get-sharable/' + hash);
    }

    static async closeEvent(params) {
        return Events.getAxiosInstance().post(Events.getApiUrl() + 'close-date', params);
    }

    static checkUserInEvent(eventId) {
        return Events.getAxiosInstance().post(Events.getApiUrl() + 'check-user/' + eventId);
    }



}